import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'

import Home from '../screens/Home'
import Resume from '../screens/Resume'

export default class AppRouter extends Component {

	render() {

		return (
			<Router>
			    <div>
			      <Route exact path="/" component={Home}/>
			      <Route path="/resume" component={Resume}/>
			    </div>
			  </Router>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/Router.js